import { h } from 'preact';
import { ArticleSurvey } from 'core_main/api/knowledge_bases/types';

import TextArea from 'widget_main/components/TextArea/TextArea';

import styles from './kbArticleSurveyFeedbackWrittenFeedback.scss';

export interface KBArticleSurveyFeedbackWrittenFeedbackProps {
  enabled: boolean;
  title: ArticleSurvey['writtenFeedbackTitle'];
  onChange: (e: Event) => void;
}
const KBArticleSurveyFeedbackWrittenFeedback = ({
  enabled,
  title,
  onChange,
}: KBArticleSurveyFeedbackWrittenFeedbackProps) => {
  if (!enabled) return null;
  return (
    <div className={styles.writtenFeedbackWrapper}>
      <label className={styles.writtenFeedbackLabel} for="writtenFeedback">
        {title}
      </label>
      <TextArea
        ariaLabel={title}
        id="writtenFeedback"
        className={styles.textArea}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={true}
        onChange={onChange}
        maxLength={350}
      />
    </div>
  );
};

export default KBArticleSurveyFeedbackWrittenFeedback;
